export default Object.freeze({
    getProtocolsForSpecies(species) {
        if (species === 1) return ['V8', 'V10', 'Antirrábica'];
        if (species === 2) return ['V3', 'V4', 'V5', 'Antirrábica'];
        return ['Antirrábica'];
    }
});
